export default __webpack_public_path__ + "static/media/aircare-3.9182c8b4.png";